module.exports = __webpack_public_path__ + "img/payout.73f8bed.png";